import { typeof as _typeof } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { ModuleConfig, ModuleIntegrationPipeline } from '../utility/module.js';

var defaultOptions = {
  tokenStoreProvider: null
};
var config = new ModuleConfig(defaultOptions);
var integrations = new ModuleIntegrationPipeline();
/**
 * Gets current configuration options for the auth module
 * @returns {object} Auth module options
 */

var getAuthModuleOptions = function getAuthModuleOptions() {
  return config.getAll();
};
/**
 * Configures options for the auth module
 * @param {object} options Options to set
 * @param {object} options.tokenStoreProvider Instance of a store provider for getting/setting auth tokens
 */


var setAuthModuleOptions = function setAuthModuleOptions(options) {
  if (options.tokenStoreProvider !== undefined && _typeof(options.tokenStoreProvider) !== "object") {
    console.warn("Unable to set default token store provider, provider is invalid");
  }

  config.setAll(options);
};

var getAuthIntegrations = function getAuthIntegrations() {
  return integrations;
};
/**
 * Configures a custom auth integration
 * @param {ModuleIntegration} integration Instance of the auth module integration
 * @param {boolean} setDefault Optional, if using multiple auth integrations whether to make this the default
 */


var enableCustomAuth = function enableCustomAuth(integration) {
  var setDefault = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  integrations.add(integration, setDefault);
}; // --- legacy methods ---

/**
 * @deprecated replaced by enableCustomAuth
 */


var useCustomAuth = function useCustomAuth(integration) {
  var setDefault = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return enableCustomAuth(integration, setDefault);
};
/**
 * @deprecated replaced by getAuthModuleOptions
 */


var getTokenStoreProvider = function getTokenStoreProvider() {
  return getAuthModuleOptions().tokenStoreProvider;
};
/**
 * @deprecated replaced by setAuthModuleOptions
 */


var setTokenStoreProvider = function setTokenStoreProvider(provider) {
  return setAuthModuleOptions({
    tokenStoreProvider: provider
  });
};

export { enableCustomAuth, getAuthIntegrations, getAuthModuleOptions, getTokenStoreProvider, setAuthModuleOptions, setTokenStoreProvider, useCustomAuth };
